import apiService from 'apiService'
import StoresSelect from 'components/Inputs/StoresSelect'
import UserRolesSelect from 'components/Inputs/UserRolesSelect'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'

// components

export default function CardUser() {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [userRole, setUserRole] = useState(null)
    const [userStores, setUserStores] = useState([])
    const history = useHistory()

    const handlerUsernameChange = e => setUsername(e.target.value)
    const handlePasswordChange = e => setPassword(e.target.value)

    const handleCreateUser = async () => {
        const payload = {
            username: username,
            password: password,
            role_id: userRole,
            stores: userStores
        }
        const response = await apiService.post(`/users`, payload)
        if (response === null) return
        toast.success('Επιτυχής δημιουργία χρήστη!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
        history.push('/admin/users')
    }
    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold">Δημιουργία Χρήστη</h6>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                    <form>
                        <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase"></h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12 px-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΟΝΟΜΑ ΧΡΗΣΤΗ</label>
                                    <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Όνομα Χρήστη" onChange={handlerUsernameChange} />
                                </div>
                            </div>
                            <div className="w-full lg:w-12 px-4">
                                <div className="relative w-full mb-3">
                                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΚΩΔΙΚΟΣ ΠΡΟΣΒΑΣΗΣ</label>
                                    <input type="password" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Κωδικός Πρόσβασης" onChange={handlePasswordChange} />
                                </div>
                            </div>
                            <UserRolesSelect handler={setUserRole} />
                            <StoresSelect handler={setUserStores} />
                        </div>
                    </form>
                </div>
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold"></h6>
                        <button className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" onClick={handleCreateUser}>
                            Δημιουργία
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
